import Axios from '../axios.js'

export default {
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单列表
	/**
	 * 根据类型分页查询工单信息列表
	 * @param {String} userList 多选 可查看用戶
	 * @param {String} orderGroupIds 多选 工单组id，可多选
	 * @param {String} orderTypeString  单选 工单类型
	 * @param {String} statusString 多选 工单状态 Create_已创建/Doing_处理中/Done_已完成/Stopping_已暂停/Deleted_已作废
	 * @param {String} priorityString 多选 优先级 Emergent_优先级/High_高/Standard_标准/Low_低
	 * @param {int} pageIndex
	 * @param {int} pageSize
	 * @param {String} creatorIds 多选 筛选创建人用户，可多人
	 * @param {String} nodeUsers 多选 筛选处理人用户，可多人
	 * @param {String} participants 多选 筛选抄送人用户，可多人
	 * @param {Long} beginTime 开始时间
	 * @param {Long} endTime 结束时间
	 */
	searchByType: (pageIndex, pageSize, orderGroupIds, orderTypeString, statusString, priorityString, creatorIds,
		nodeUsers, participants, beginTime, endTime, userList, success, failure) => {
		Axios.post('/work/searchByType.do', {
			userList,
			orderGroupIds,
			orderTypeString,
			statusString,
			priorityString,
			pageIndex,
			pageSize,
			creatorIds,
			nodeUsers,
			participants,
			beginTime,
			endTime
		}, success, failure);
	},
	searchByTypes: (pageIndex, pageSize, orderGroupIds, orderTypeString, statusString, priorityString, creatorIds,
		nodeUsers, participants, beginTime, endTime, userList, success, failure) => {
		Axios.post('/work/searchByTypes.do', {
			userList,
			orderGroupIds,
			orderTypeString,
			statusString,
			priorityString,
			pageIndex,
			pageSize,
			creatorIds,
			nodeUsers,
			participants,
			beginTime,
			endTime
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单列表
	/**
	 * 根据类型分页查询工单信息列表
	 * @param {String} userList 多选 可查看用戶
	 * @param {String} orderGroupIds 多选 工单组id，可多选
	 * @param {String} orderTypeString  单选 工单类型
	 * @param {String} statusString 多选 工单状态 Create_已创建/Doing_处理中/Done_已完成/Stopping_已暂停/Deleted_已作废
	 * @param {String} priorityString 多选 优先级 Emergent_优先级/High_高/Standard_标准/Low_低
	 * @param {String} creatorIds 多选 筛选创建人用户，可多人
	 * @param {String} nodeUsers 多选 筛选处理人用户，可多人
	 * @param {String} participants 多选 筛选抄送人用户，可多人
	 * @param {Long} beginTime 开始时间
	 * @param {Long} endTime 结束时间
	 */
	searchCountByType: (orderGroupIds, orderTypeString, statusString, priorityString, creatorIds, nodeUsers, participants,
		beginTime, endTime, userList, success, failure) => {
		Axios.post('/work/searchCountByType.do', {
			userList,
			orderGroupIds,
			orderTypeString,
			statusString,
			priorityString,
			creatorIds,
			nodeUsers,
			participants,
			beginTime,
			endTime
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++添加工单
	/**
	 * 创建工单
	 * @param {Long}   groupId 工单组id
	 * @param {String} orderTypeString 工单类型 Order:一次性工单,CycleOrder:周期工单,OrderTemplate:工单模板
	 * @param {String} title 工单主题
	 * @param {String} content 工单描述（富文本）
	 * @param {String} cycleType 周期类型： day_日/week_周/month_月/yesr_年
	 * @param {Long}   startTimeLong 工单执行开始时间 时间戳
	 * @param {Long}   workDay 完工期限 以毫秒为单位 用户选择的日期减去当前时间得到的毫秒值
	 * @param {String} resourceIds 关联附件id,逗号隔开
	 * @param {String} nodes 自定义节点  json数组，里面放多个对象，每个对象两个值，一个name放节点名称，一个list放多个用户列表
	 * @param {String} participants 抄送人 多个用户用逗号隔开
	 * @param {String} request 工单申请
	 */
	addOrder: (groupId, orderTypeString, title, content, startTime, workDay, resourceIds, cycleType,
		nodes, participants, success, failure) => {
		Axios.post('/work/addOrder.do', {
				groupId,
				orderTypeString,
				title,
				content,
				startTime,
				workDay,
				resourceIds,
				cycleType,
				nodes,
				participants
			},
			success, failure);
	},
	/**
	 * 彻底删除作废工单
	 */
	deleteByOrderIds(orderIds, success, failure) {
		Axios.post('/work/deleteByOrderIds.do', {
			orderIds
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单详情
	/**
	 * 工单详情
	 * @param {String} orderId 工单id
	 */
	getOrderInfoById: (orderId, success, failure) => {
		Axios.post('/work/getOrderInfoById.do', {
			orderId
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单操作步骤
	/**
	 * 保存检查内容
	 * @param {Long} orderId
	 * @param {JsONObject} inputData 格式为执行步骤id做key,处理人填写的内容值做value
	 */
	updateCheckAction: (orderId, inputData, success, failure) => {
		Axios.post('/work/updateCheckAction.do', {
			orderId,
			inputData
		}, success, failure);
	},
	/**
	 * 忽略检查内容
	 * @param {Long} orderId
	 * @param {Long} actionIds 被忽略的步驟id,多个用逗号隔开
	 */
	ignoreCheckAction: (orderId, actionIds, success, failure) => {
		Axios.post('/work/ignoreCheckAction.do', {
			orderId,
			actionIds
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单节点确认完成
	/**
	 * 确认节点完成
	 * @param {Long} orderId
	 * @param {Long} nodeId 被忽略的步驟id,多个用逗号隔开
	 */
	confirmNode: (orderId, nodeId, success, failure) => {
		Axios.post('/work/confirmNode.do', {
			orderId,
			nodeId
		}, success, failure);
	},
	/**
	 * 回滚到上一步
	 */
	nodeReturn: (orderId, nodeId, success, failure) => {
		Axios.post('/work/nodeReturn.do', {
			orderId,
			nodeId
		}, success, failure);
	},
	/**
	 * 添加抄送人
	 */
	addParticipantsInNode: (orderId, participants, success, failure) => {
		Axios.post('/work/addParticipantsInNode.do', {
			orderId,
			participants
		}, success, failure);
	},
	/**
	 * 移除抄送人
	 */
	removeParticipantsInNode: (orderId, participants, success, failure) => {
		Axios.post('/work/removeParticipantsInNode.do', {
			orderId,
			participants
		}, success, failure);
	},
	/**
	 * 转派节点负责人
	 */
	replaceNodeUser: (orderId, newUserId, success, failure) => {
		Axios.post('/work/replaceNodeUser.do', {
			orderId,
			newUserId
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单中止完成
	/**
	 * 中止完成工单
	 * @param {Long} orderId
	 * @param {String} reason 中止原因
	 */
	breakOffByOrderId: (orderId, reason, success, failure) => {
		Axios.post('/work/breakOffByOrderId.do', {
			orderId,
			reason
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单暂停
	/**
	 * 暂停工单
	 * @param {Long} orderId
	 * @param {String} reason 暂停原因
	 */
	stoppingByOrderId: (orderId, reason, success, failure) => {
		Axios.post('/work/stoppingByOrderId.do', {
			orderId,
			reason
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单作废
	/**
	 * 作废工单
	 * @param {String} orderIds 需作废工单的id，多个用逗号隔开
	 */
	removeByOrderIds: (orderIds, success, failure) => {
		Axios.post('/work/removeByOrderIds.do', {
			orderIds
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++工单恢复
	/**
	 * 恢复已作废已暂停的工单
	 * @param {String} orderIds 需恢复工单的id，多个用逗号隔开
	 */
	restoreByOrderIds: (orderIds, success, failure) => {
		Axios.post('/work/restoreByOrderIds.do', {
			orderIds
		}, success, failure);
	},
	//+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++统计
	/**
	 * 查询指定单位的指定时间段每个类型的工单的总计
	 */
	countOrderListByUnit: (unitId, startTime, endTime, success, failure) => {
		Axios.post('/work/countOrderListByUnit.do', {
			unitId,
			startTime,
			endTime,
		}, success, failure);
	},
}